import { render, staticRenderFns } from "./dialogImportData.vue?vue&type=template&id=10c5c804&"
import script from "./dialogImportData.vue?vue&type=script&lang=js&"
export * from "./dialogImportData.vue?vue&type=script&lang=js&"
import style0 from "./dialogImportData.vue?vue&type=style&index=0&id=10c5c804&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports